export default class ProfileModel {
    constructor(obj){
        obj = obj || {};
        // The parseInt is needed for the v-autocomplete mapping
        this.id = obj.id != null && obj.id !== '' ? parseInt(obj.id, 10) : undefined;
        this.description = obj.description;
        this.createdAt = obj.createdAt;
        this.updatedAt = obj.updatedAt;
    }
}